export default __webpack_public_path__ + "static/media/Group 6.fb0bc6a6.png";